
import api from '../../plugins/api';

const getEquipments = (params) => {
  return api.get('/api/crm/equipments/get', params);
};

export default getEquipments;
